import { Map } from 'immutable';

import { updateUser } from './action';

export interface UserPreferences {
  useChemelexUi?: boolean;
  chemelexUiBannerDismissed?: boolean;
}

export const getUserPreference = <K extends keyof UserPreferences>(
  authentication: Map<string, any>,
  key: K
) => authentication.getIn(['user', 'preferences', key]) as UserPreferences[K] | undefined;

export const updateUserPreferences = (preferences: UserPreferences) =>
  updateUser(null, Map(preferences));
